/**
 * This ReportType Enum is going to be used for the new report generation tooling.
 */
exports.ById = {
  0: { Id: 0, Name: 'NoReports', Localization: 'report.no_reports' },
  1: { Id: 1, Name: 'Pending', Localization: 'report.pending' },
  2: { Id: 2, Name: 'Generated', Localization: 'report.generated' },
  3: { Id: 3, Name: 'Failed', Localization: 'report.failed' },
  4: { Id: 4, Name: 'Uploaded', Localization: 'report.uploaded' },
  5: { Id: 5, Name: 'Converting', Localization: 'report.converting' }
};

exports.ByName = {
  NoReports: { Id: 0, Name: 'NoReports', Localization: 'report.no_reports' },
  Pending: { Id: 1, Name: 'Pending', Localization: 'report.pending' },
  Generated: { Id: 2, Name: 'Generated', Localization: 'report.generated' },
  Failed: { Id: 3, Name: 'Failed', Localization: 'report.failed' },
  Uploaded: { Id: 4, Name: 'Uploaded', Localization: 'report.uploaded' },
  Converting: { Id: 5, Name: 'Converting', Localization: 'report.converting' }
};
